import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useInfoItemDefaultStyles } from '../../styles';

export const InfoItemDefault = ({
  name,
  value,
}) => {
  const classes = useInfoItemDefaultStyles();

  return (
    <div className={classes.contentItem}>
      <div className={classes.contentName}>{name}</div>
      <div className={classnames(classes.contentValue, 'info-value')}>{value}</div>
    </div>
  );
};

InfoItemDefault.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
